// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    width: 50%;
    padding: 20px;
    z-index: 1000;
  }
  
  .modal-header {
    display: flex;
    justify-content: flex-end;
  }

  .close-x{
    position:fixed;
    right:2px;
    top:5px;
  }
  
  .tab-header {
    position:relative;
    top:21px;
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
  }

  
  .tab-button:focus {
    background-color: #007bff !important;
    color:white;
    border-bottom: 2px solid #0056b3 !important;
  }
  
  .tab-content {
    padding: 20px;
    font-size: 1.1rem;
  }

  @media(max-width:732px){
    .tab-button{
      padding-left:1px;
      padding-right:1px;
      width:100%;
    }

    .tab-content {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  @media(max-width:732px){
    .tab-button{
      padding-left:1px;
      padding-right:1px;
      width:100%;
    }

    .tab-content {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  @media(max-width:500px){
    .tab-content {
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  @media(max-width:400px){
    .tab-content {
      padding-left: 2px;
      padding-right: 2px;
    }
  }
  
  .language-switcher {
    text-align: center;
    margin-top: 20px;
  }

  `, "",{"version":3,"sources":["webpack://./src/css/StaticForm.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,yCAAyC;IACzC,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,aAAa;EACf;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,SAAS;IACT,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,aAAa;IACb,6BAA6B;IAC7B,6BAA6B;IAC7B,mBAAmB;EACrB;;;EAGA;IACE,oCAAoC;IACpC,WAAW;IACX,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE;MACE,gBAAgB;MAChB,iBAAiB;MACjB,UAAU;IACZ;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,gBAAgB;MAChB,iBAAiB;MACjB,UAAU;IACZ;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":[".modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    width: 50%;\n    padding: 20px;\n    z-index: 1000;\n  }\n  \n  .modal-header {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .close-x{\n    position:fixed;\n    right:2px;\n    top:5px;\n  }\n  \n  .tab-header {\n    position:relative;\n    top:21px;\n    display: flex;\n    justify-content: space-around;\n    border-bottom: 1px solid #ccc;\n    margin-bottom: 10px;\n  }\n\n  \n  .tab-button:focus {\n    background-color: #007bff !important;\n    color:white;\n    border-bottom: 2px solid #0056b3 !important;\n  }\n  \n  .tab-content {\n    padding: 20px;\n    font-size: 1.1rem;\n  }\n\n  @media(max-width:732px){\n    .tab-button{\n      padding-left:1px;\n      padding-right:1px;\n      width:100%;\n    }\n\n    .tab-content {\n      padding-left: 10px;\n      padding-right: 10px;\n    }\n  }\n\n  @media(max-width:732px){\n    .tab-button{\n      padding-left:1px;\n      padding-right:1px;\n      width:100%;\n    }\n\n    .tab-content {\n      padding-left: 10px;\n      padding-right: 10px;\n    }\n  }\n\n  @media(max-width:500px){\n    .tab-content {\n      padding-left: 5px;\n      padding-right: 5px;\n    }\n  }\n\n  @media(max-width:400px){\n    .tab-content {\n      padding-left: 2px;\n      padding-right: 2px;\n    }\n  }\n  \n  .language-switcher {\n    text-align: center;\n    margin-top: 20px;\n  }\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
